import React, { Component } from 'react';
import { RightOutlined, CheckOutlined } from '@ant-design/icons';

const STATUS_READY = 1;
const STATUS_COMPLETED = 2;

class SliderOnly extends Component {
    state = {
        isMovable: false,
        startX: 0,
        currX: 0,
        status: STATUS_READY,
    };

    componentDidMount() {
        document.addEventListener('mousemove', this.onGlobalMoving);
        document.addEventListener('mouseup', this.onGlobalMoveEnd);
    }

    componentWillUnmount() {
        document.removeEventListener('mousemove', this.onGlobalMoving);
        document.removeEventListener('mouseup', this.onGlobalMoveEnd);
    }

    onMoveStart = (e) => {
        if (this.state.status !== STATUS_READY) return;
        this.setState({ isMovable: true, startX: e.clientX, startCurrX: this.state.currX });
    };

    onGlobalMoving = (e) => {
        if (!this.state.isMovable) return;
        const distance = e.clientX - this.state.startX;
        let currX = this.state.startCurrX + distance;
        const minX = 0;
        const maxX = this.props.width - this.props.fragmentSize;
        currX = currX < minX ? minX : currX > maxX ? maxX : currX;
        this.setState({ currX });
    };

    onGlobalMoveEnd = () => {
        if (!this.state.isMovable) return;
        this.setState({ isMovable: false });

        const maxX = this.props.width - this.props.fragmentSize;
        if (this.state.currX >= maxX - 10) {
            this.setState({ status: STATUS_COMPLETED });
            this.props.onSuccess();
        } else {
            // 如果没有滑动到成功位置，则返回原点
            this.setState({ currX: 0 });
        }
    };

    render() {
        const { width, fragmentSize, color, tdrage, inforScuess } = this.props;
        const sliderStyle = {
            width: fragmentSize,
            height: '100%',
            position: 'absolute',
            color: color,
            left: `${this.state.currX}px`,
            cursor: this.state.isMovable ? 'grabbing' : 'grab',
            zIndex: 200, // 确保滑块在移动区域之上
        };

        // 移动过的区域样式
        const filledAreaStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: `${this.state.currX + fragmentSize - 3}px`,
            height: '38px',
            margin: '1.3px',
            backgroundColor: color, // 移动过的区域颜色
            borderRadius: '5px',
            opacity: 1,
            zIndex: 1, // 确保移动区域在滑块之下
            transition: 'width 0.1s ease', // 添加平滑过渡效果
        };

        return (
            <div className="slider-container" style={{ width, position: 'relative', height: '40px' }}>
                {/* 移动过的区域 */}
                <div style={filledAreaStyle}></div>
                {/* 文字内容 */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 99,
                    width: '100%',
                    textAlign: 'center',
                    pointerEvents: 'none',
                }}>
                    {this.state.status !== STATUS_COMPLETED && (
                        <div style={{ color: '#8a8eab', zIndex: 999999, fontSize: '14px' }}>
                            {tdrage}
                        </div>
                    )}
                    {this.state.status === STATUS_COMPLETED && (
                        <div style={{ color: '#8a8eab', zIndex: 999999, fontSize: '14px' }}>
                            {inforScuess}
                        </div>
                    )}
                </div>
                {/* 滑块轨道背景 */}
                <div className="slider-track" style={{ height: '100%', backgroundColor: '#e5e5ee', position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 0 }}></div>
                {/* 滑块 */}
                <div className="slider-thumb" style={sliderStyle} onMouseDown={this.onMoveStart}>
                    {this.state.status === STATUS_COMPLETED && (
                        <div style={{ color: 'themeColor' }}>
                            <CheckOutlined />
                        </div>
                    )}
                    {this.state.status !== STATUS_COMPLETED && (
                        <div>
                            <RightOutlined />
                            <RightOutlined />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default SliderOnly;